function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react';
import ProGallery from './proGallery';
import GALLERY_EVENTS from '../../common/constants';
import CloseButton from '../svgs/components/x';
var styles = {
  gallery: {},
  fullscreen: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 9,
    background: 'white'
  },
  close: {
    boxSizing: 'content-box',
    zIndex: 10,
    padding: 10,
    position: 'fixed',
    right: 10,
    top: 10,
    background: 'rgba(255,255,255,0.8)',
    borderRadius: 4,
    width: 25,
    height: 25,
    fill: 'black'
  }
};

var ExpandableProGallery =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ExpandableProGallery, _React$Component);

  function ExpandableProGallery(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.eventListener = _this.eventListener.bind(_assertThisInitialized(_this));
    _this.state = {
      fullscreenIdx: -1
    };
    return _this;
  }

  var _proto = ExpandableProGallery.prototype;

  _proto.eventListener = function eventListener(eventName, eventData) {
    switch (eventName) {
      case GALLERY_EVENTS.ITEM_ACTION_TRIGGERED:
        this.setState({
          fullscreenIdx: eventData.idx
        });
        break;

      default:
        // console.log({eventName, eventData});
        break;
    }

    if (typeof this.props.eventsListener === 'function') {
      this.props.eventsListener(eventName, eventData);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return React.createElement(React.Fragment, null, React.createElement("section", {
      style: _objectSpread({}, styles.gallery, {
        display: this.state.fullscreenIdx < 0 ? 'block' : 'none'
      })
    }, React.createElement(ProGallery, _extends({
      key: "pro-gallery-" + this.props.domId
    }, this.props, {
      eventsListener: this.eventListener
    }))), this.state.fullscreenIdx >= 0 && React.createElement("section", {
      style: _objectSpread({}, styles.fullscreen, {
        display: this.state.fullscreenIdx >= 0 ? 'block' : 'none'
      })
    }, React.createElement(CloseButton, {
      style: styles.close,
      onClick: function onClick() {
        return _this2.setState({
          fullscreenIdx: -1
        });
      }
    }), React.createElement(ProGallery, _extends({}, this.props, {
      currentIdx: this.state.fullscreenIdx,
      container: {
        width: window.innerWidth,
        height: window.innerHeight - 100
      },
      styles: _objectSpread({}, this.props.options || this.props.styles, {
        galleryLayout: 5,
        slideshowInfoSize: 100,
        cubeType: 'fit',
        scrollSnap: true
      })
    }))));
  };

  return ExpandableProGallery;
}(React.Component);

export { ExpandableProGallery as default };